import React from "react";
import NumberInput from "../../../../common/NumberInput";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

class Decimal extends React.Component {
  render() {
    const {
      t,
      indicateur,
      sousRubriqueIndex,
      libelleEnglobantIndex,
      changeIndicateur,
      valueInputProps,
      computedFields,
      size,
    } = this.props;

    const valeurCalculee = (
      <NumberInput
        size={size}
        style={{ width: "8rem" }}
        fullWidth={false}
        InputProps={valueInputProps}
        disabled
        value={indicateur.valeurCalculee?.value ?? ""}
        label={t("hve3a.valeur-mesparcelles", "Valeur MesParcelles")}
        className={"mr-2"}
      />
    );

    const valueRendered = (
      <NumberInput
        size={size}
        fullWidth={false}
        value={indicateur.valeur.value ?? ""}
        InputProps={valueInputProps}
        allowNegative={true}
        disabled={computedFields.includes(indicateur.codeNational)}
        style={{
          fontWeight: indicateur.afficherGras ? "bold" : "normal",
          width: "8rem",
        }}
        onChange={(newValeur) =>
          changeIndicateur(
            { ...indicateur, valeur: { value: newValeur === "" ? null : Number(newValeur) } },
            sousRubriqueIndex,
            libelleEnglobantIndex
          )
        }
      />
    );

    return (
      <React.Fragment>
        {!!indicateur.valeurCalculee && valeurCalculee}
        {valueRendered}
      </React.Fragment>
    );
  }
}

export default compose(withTranslation())(Decimal);
